import { render, staticRenderFns } from "./en-primeur.vue?vue&type=template&id=72045f48&scoped=true"
import script from "./en-primeur.vue?vue&type=script&lang=js"
export * from "./en-primeur.vue?vue&type=script&lang=js"
import style0 from "./en-primeur.vue?vue&type=style&index=0&id=72045f48&prod&scoped=true&lang=css"
import style1 from "./en-primeur.vue?vue&type=style&index=1&id=72045f48&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72045f48",
  null
  
)

export default component.exports